import { PredefinedOptionType } from '../../enum';
import { EventType, ItemType } from '../../lib';
import { isArticleOption, isSectionOption } from '../../lib/option';
import { ArticleInteractionExternEvent, ArticleListNavigationEvent, ResolutionEvent, SystemOptionEvent } from '../../types';

export function isSectionOptionEvent (event: any): event is SystemOptionEvent {
  return EventType.isOptionEvent(event) && isSectionOption(event.payload.selected);
}

export function isArticleOptionEvent (event: any): event is SystemOptionEvent {
  return EventType.isOptionEvent(event) && isArticleOption(event.payload.selected);
}

export function isArticleFromListNavigationEvent (event: any): event is ArticleListNavigationEvent {
  return EventType.isArticleListNavigationEvent(event) && isArticleOption(event.payload.selected);
}

export function isOverlongResolutionEvent (event: any): event is ResolutionEvent {
  return EventType.isResolutionEvent(event) && ItemType.isOverlongAiConversationResolutionMessage(event.message);
}

export function isStaleConversationResolutionEvent (event: any): event is ResolutionEvent {
  return EventType.isResolutionEvent(event) && ItemType.isStaleAiConversationResolutionMessage(event.message);
}

export function isArticleSupportRequestEvent (event: any): event is ArticleInteractionExternEvent {
  return EventType.isArticleInteractionEvent(event) && event.payload.interaction === 'support-request';
}

export function isBrowseOtherArticlesEvent (event: any): event is ArticleListNavigationEvent {
  return EventType.isArticleListNavigationEvent(event) && event.payload.selected === PredefinedOptionType.BROWSE_OTHER_ARTICLES;
}

export function isIssueNotListedArticlesEvent (event: any): event is ArticleListNavigationEvent {
  return EventType.isArticleListNavigationEvent(event) && event.payload.selected === PredefinedOptionType.ISSUE_NOT_LISTED;
}
